// hooks/useCreateGroup.ts
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postAPI } from '../services/api.service';
import { GroupCreateType } from '../Types/Group.type';

export const useCreateGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCreateGroup = async (data: GroupCreateType) => {
    // from local storage get userId
    const user: { id?: string } = JSON.parse(localStorage.getItem('user') || '{}');

    // Ensure a groupLeader is present (mandatory now)
    if (!data.groupLeader) {
      toast.error('Please select a group leader.');
      return;
    }

    setLoading(true);
    try {
      // Your backend expects createdBy/user context — keep existing behavior
      const payload = { ...data, user: { id: user?.id } };
      const response = await postAPI<{ message: string }>('/groups/create', payload);
      if (response.status === 201) {
        toast.success('Group created successfully!');
        navigate(`${process.env.PUBLIC_URL}/group/group_list`);
      } else {
        // try to surface backend message if present
        const msg = (response?.data?.message) || 'Failed to create group. Please try again.';
        toast.error(msg);
      }
    } catch (error: any) {
      const message = error?.response?.data?.message || 'An error occurred while creating the group.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return { handleCreateGroup, loading };
};
